import { useRef, useState } from 'react';
import AnimatedDemoExtended from '../components/landing/AnimatedDemoExtended';
import { Activity, Hand } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

export default function DemoStandPage() {
  const formUrl = `${window.location.origin}/?demo=solicitar`;
  const demoRef = useRef(null);
  const pageRef = useRef(null);
  const [kioskStarted, setKioskStarted] = useState(false);

  const startKiosk = () => {
    setKioskStarted(true);
    pageRef.current?.requestFullscreen?.().catch(() => {});
    demoRef.current?.enableAudio();
  };

  return (
    <div ref={pageRef} className="min-h-screen bg-slate-950 flex flex-col" data-testid="demo-stand-page">
      {!kioskStarted && (
        <button onClick={startKiosk} className="fixed inset-0 z-50 bg-slate-950/95 flex flex-col items-center justify-center gap-5 cursor-pointer" data-testid="kiosk-start-overlay">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center shadow-2xl shadow-cyan-500/40">
            <Activity className="w-9 h-9 text-white" />
          </div>
          <div className="text-3xl md:text-4xl font-bold text-white">Simu<span className="text-cyan-400">Clinic</span></div>
          <div className="flex items-center gap-3 bg-cyan-500/15 border border-cyan-500/40 rounded-full px-6 py-3" style={{ animation: 'pulse 2s ease-in-out infinite' }}>
            <Hand className="w-5 h-5 text-cyan-300" />
            <span className="text-cyan-200 text-base md:text-lg font-semibold">Toca la pantalla para comenzar</span>
          </div>
          <p className="text-slate-500 text-sm">Pantalla completa · Audio activado</p>
        </button>
      )}
      <div className="flex-1 flex items-center justify-center p-4 md:p-10">
        <div className="w-full max-w-6xl">
          <AnimatedDemoExtended ref={demoRef} loop withAudio />
        </div>
      </div>
      <div className="pb-8 px-4 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10">
        <div className="text-center md:text-right">
          <div className="inline-flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
              <Activity className="w-5 h-5 text-white" />
            </div>
            <span className="text-white font-bold text-xl">Simu<span className="text-cyan-400">Clinic</span></span>
          </div>
          <p className="text-cyan-300 font-medium">Solicita una demostración</p>
          <p className="text-slate-400 text-sm">www.simuclinic.cl · contacto@simuclinic.cl</p>
        </div>
        <div className="flex flex-col items-center gap-2" data-testid="stand-qr">
          <div className="bg-white p-3 rounded-xl shadow-lg shadow-cyan-500/20">
            <QRCodeSVG value={formUrl} size={132} level="M" fgColor="#0f172a" />
          </div>
          <p className="text-slate-300 text-xs font-medium max-w-[170px] text-center">
            Escanea con tu celular y solicita una demostración
          </p>
        </div>
      </div>
    </div>
  );
}
